<template>
    <div class="actions" @click="$emit('close')">
        <!-- Для итемов с подтверждением -->
        <!-- <div class="actions" v-if="deleting" @click.stop>
            <div class="actions-container choise" @click.stop>
                <h3 class="actions__title">Вы действительно хотите удалить {{settings.type === 'pin' ? 'пост' : 'комментарий'}}?</h3>
                <div class="actions-buttons">
                    <div class="button" @click="deleteEl()">
                        <p v-if="!loading">Да</p>
                    </div>
                    <div class="button" @click="deleting = false">Нет</div>
                </div>
            </div>
        </div> -->
        <div class="actions-container" @click.stop>
            <div class="actions-item" 
                v-for="(option, index) in options"
                :key="index"
                :class="{red: option.important}"
                @click="$emit('action', option)">
                <p>{{ option.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'Actions',
    props: {
        options: {
            type: Array,
            required: true
        }
    },
    methods: {
    }
}
</script>
<style lang="stylus" scoped>
.actions
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    display flex
    align-items center
    justify-content center
    z-index 5
    padding 20px

    &-container
        width 450px
        background-color white
        border-radius 20px
        box-shadow 0px 0px 30px rgba(162, 162, 162, 0.25)
        &.choise
            padding 40px
    
    &__title
        text-align center
        font-size 22px
        font-weight 500
        line-height 28px

    &-buttons
        display flex
        justify-content center
        margin-top 20px
        .button
            margin 0 15px

    &-item
        display flex
        justify-content center
        padding 15px 0
        font-size 16px
        font-weight 500
        border-bottom 1px solid #f0f0f0
        cursor pointer
        &:last-child
            border-bottom 0
        &.red
            color red
</style>